import React, { memo, useCallback, useContext } from 'react';
import { useMainContext } from "../../../main-context";
import { colors } from "../../constants";
import FooterContext from "../../footer-context";
import { BlankLinkSeparator, Link, LinkSeparator, LinkWrapper } from "./cookie-policy-settings-link.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CookiePolicySettingsLink = function CookiePolicySettingsLink() {
  var _useContext = useContext(FooterContext),
    palette = _useContext.palette,
    onCookiePolicySettingsClick = _useContext.onCookiePolicySettingsClick;
  // @ts-expect-error: useMainContext not TS
  var _useMainContext = useMainContext(),
    t = _useMainContext.t;
  var handleClick = useCallback(function (event) {
    var _window, _window$OneTrust, _window$OneTrust$Togg;
    // @ts-expect-error: investigate how to extend the Window type
    (_window = window) === null || _window === void 0 ? void 0 : (_window$OneTrust = _window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : (_window$OneTrust$Togg = _window$OneTrust.ToggleInfoDisplay) === null || _window$OneTrust$Togg === void 0 ? void 0 : _window$OneTrust$Togg.call(_window$OneTrust);
    onCookiePolicySettingsClick(event);
  }, [onCookiePolicySettingsClick]);
  return /*#__PURE__*/_jsxs(LinkWrapper, {
    children: [/*#__PURE__*/_jsx(Link, {
      as: "button",
      onClick: handleClick,
      color: colors[palette],
      align: "left",
      children: t('public-footer.cookie-policy-settings-link.text')
    }), /*#__PURE__*/_jsx(LinkSeparator, {}), /*#__PURE__*/_jsx(Link, {
      color: colors[palette],
      align: "left",
      href: t('public-footer.cookie-delete-link.href'),
      children: t('public-footer.cookie-delete-link.text')
    }), /*#__PURE__*/_jsx(BlankLinkSeparator, {}), /*#__PURE__*/_jsx(Link, {
      target: "_blank",
      color: colors[palette],
      align: "left",
      href: t('common.link.report-abuse.url'),
      children: t('common.link.report-abuse.text')
    })]
  });
};
export default /*#__PURE__*/memo(CookiePolicySettingsLink);